import { useOutletContext } from 'react-router-dom';
import { useEffectOnce } from 'react-use';

import { websocketActions } from 'app/middleware/websocket/actions/websocket';
import { mediaAttributes } from 'utils/channels/media';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppPathParams } from 'utils/url/useAppPathParams';

import { TvDashboardViewOutletContext } from '../../tvDashboard.view';
import { useTvDashboardReloadEffect } from '../../utils/useTvDashboardReloadEffect';

import { TvChannelDashboardMetrics } from './components/metrics/tvChannelDashboardMetrics';

export const TvChannelDashboardView = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { media } = useAppPathParams('/tv/dashboard/channels/:media');
  const { setTitle } = useOutletContext<TvDashboardViewOutletContext>();

  useEffectOnce(() => {
    setTitle(mediaAttributes[media].name);

    dispatch(
      websocketActions.request({
        type: 'connection:subscribe',
        params: {
          type: 'real_time_dashboard',
          dashboard_type: 'channel',
        },
      }),
    );

    return () => {
      dispatch(
        websocketActions.request({
          type: 'connection:unsubscribe',
          params: {
            type: 'real_time_dashboard',
            dashboard_type: 'channel',
          },
        }),
      );
    };
  });

  useTvDashboardReloadEffect('channel');

  return <TvChannelDashboardMetrics media={media} />;
};
